import {Popover, PopoverContent, PopoverTrigger} from "../../shadCn/components/ui/popover";
import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem} from "../../shadCn/components/ui/command";
import {CommandList} from "cmdk";
import {Check} from "lucide-react";
import {cn} from "../../shadCn/lib/utils";
import {useEffect, useMemo, useState} from "react";
import {Label} from "../drawer/drawer/Style";
import {ChevronDownIcon} from "../selector/SelectorIcons";
import "../selector/selector.css";

function SearchComboBox({title, code, target, value, search, onChange}) {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(value?.[target] ?? undefined);

    useEffect(() => {
        setData(value?.[target]);
    }, [value, target]);

    const selectedOption = useMemo(
        () => (data != null ? code?.find((option) => option.id === data) : null),
        [code, data],
    );
    const hasSelection = selectedOption != null;
    const triggerLabel = hasSelection ? selectedOption.name : "선택";

    const handler = (_target, selected) => {
        setData(data === selected ? null : selected);
        onChange(selected);
        setOpen(false);
    };

    if (!code) {
        return null;
    }

    return (
        <div className="simms-drawer-field selector-field selector-field--inline search-combobox-field">
            <Label>{title}</Label>

            <div className="selector-root selector-root--ios no-drag">
                <Popover open={open} onOpenChange={setOpen}>
                    <PopoverTrigger asChild>
                        <div
                            className={[
                                "selector-trigger simms-drawer-trigger",
                                hasSelection ? "is-selected" : "",
                                open ? "is-open" : "",
                            ].filter(Boolean).join(" ")}
                            role="combobox"
                            aria-expanded={open}
                        >
                            <span className={`selector-trigger-label ${hasSelection ? "is-selected" : ""}`}>
                                {triggerLabel}
                            </span>
                            <ChevronDownIcon className={`selector-trigger-chevron ${open ? "is-open" : ""}`} />
                        </div>
                    </PopoverTrigger>

                    <PopoverContent className="w-[200px] p-0 ignore-click" align="start">
                        <Command>
                            {search && (
                                <>
                                    <CommandInput placeholder="검색" />
                                    <CommandEmpty>검색결과 없음</CommandEmpty>
                                </>
                            )}
                            <CommandGroup>
                                <CommandList className="max-h-[10rem] overflow-y-auto w-full">
                                    {code.map((option) => (
                                        <CommandItem
                                            key={option.id}
                                            value={String(option.id)}
                                            onSelect={() => handler(target, option.id)}
                                            className="text-[12px]"
                                        >
                                            <Check
                                                className={cn(
                                                    "mr-2 h-4 w-4",
                                                    data === option.id ? "opacity-100" : "opacity-0",
                                                )}
                                            />
                                            {option.name}
                                        </CommandItem>
                                    ))}
                                </CommandList>
                            </CommandGroup>
                        </Command>
                    </PopoverContent>
                </Popover>
            </div>
        </div>
    );
}

export {SearchComboBox};
